/**
 * Index / Home Page
 **/

import fadeAnimation from '../modules/fadeAnimation'
import 'slick-carousel'
import '../modules/switchingTabs'

if (document.body.classList.contains('page--home')) {
  document.addEventListener('DOMContentLoaded', (e) => {
    // Set up fade animations
    const animatedElements = document.querySelectorAll('.animated')
    new fadeAnimation(animatedElements)

    let windowWidth = window.innerWidth;

    $('.js-case-study-carousel').slick({
      accessibility: true,
      dots: false,
      infinite: windowWidth <= 1024,
      fade: windowWidth <= 1024,
      arrows: windowWidth <= 1024,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      swipe: false,
      swipeToSlide: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
          }
        }
      ]
    })
  })
}